<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.service.actions.removeAddOn.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Service } from '~/_api/models/service'
import type { ServiceAssociation } from '~/_api/models/serviceAssociation'

interface Props {
  service: Service
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'update:service', value: any): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const serviceAssociation = ref<ServiceAssociation | null>(null)

const info = computed(() => {
  return $i18n.t('components.service.actions.removeAddOn.info', { title: (serviceAssociation.value as any)?.target?.title, id: (serviceAssociation.value as any)?.target?.idService })
})

const open = (association: ServiceAssociation) => {
  serviceAssociation.value = association
  dialog.value.open()
}

const confirm = async () => {
  if (!serviceAssociation.value) return

  emit('update:loading', true)

  try {
    const response = await $api.service.removeAssociation(props.service, serviceAssociation.value)
    emit('update:loading', false)

    if (response.data) {
      $notification.toast({
        title: $i18n.t('components.service.actions.removeAddOn.success'),
        text: $i18n.t('components.service.actions.removeAddOn.successInfo', { title: (serviceAssociation.value as any)?.target?.title }),
        variant: 'success',
      })

      emit('success')
      emit('update:service', response.data)

      return true
    }
  } catch (e: any) {
    console.log(e)
    $notification.toast({
      title: $i18n.t('components.service.actions.removeAddOn.error'),
      text: $i18n.t('components.service.actions.removeAddOn.errorInfo', { title: (serviceAssociation.value as any)?.target?.title }),
      variant: 'danger',
    })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
